import objectFitVideos from 'object-fit-videos';
objectFitVideos(document.querySelectorAll('.slx-homebg__video'));
